import { EnvEnum, Environment } from 'editor/src/environment/types';

const env: Environment = {
  production: false,
  env: EnvEnum.dev,
  translationsUrl: 'http://localhost:4202/translations/',
  amplitudeKey: '',
  shutterstockKeys: {
    essentials: 'G1PTOJzNrrvaESrDlGCeGrGpu7XdSICQ',
    full: 'nNJwspGEM8GtBdqnU2FyGk1Qcr8fQXf0',
  },
};

export default env;
